import React from 'react';

export default function FooterLayout() {
  return (
    <footer>
      <div className="text-center">
        <p className="mb-0">
          2025 © CMS Ồn Coffee. Design by{' '}
          <a
            href="./"
            target="_blank"
            rel="noreferrer"
          >
            T & T
          </a>
        </p>
      </div>
    </footer>
  );
}
